import React from 'react';

/**
 * Popup when daily refresh limit is reached. Explains the limit and when the user can try again.
 * Same style as onboarding/confirmation modals: centred card, grey overlay.
 */
const DailyLimitModal = ({ isOpen, onClose, nextAllowedAtISO = null, platformLabel = 'this platform' }) => {
  if (!isOpen) return null;

  const tryAgainTime = nextAllowedAtISO
    ? new Date(nextAllowedAtISO).toLocaleString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/60 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl">
        <h2 className="text-base font-semibold text-slate-900">
          Daily limit reached
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          You&apos;ve used your daily refresh limit for {platformLabel}. Your stats are still saved; you can update them again later.
        </p>
        {tryAgainTime && (
          <p className="mt-3 text-sm font-medium text-slate-700">
            You can return at <span className="text-[#1B9DA2]">{tryAgainTime}</span> to refresh and update this social.
          </p>
        )}
        {!tryAgainTime && (
          <p className="mt-3 text-sm font-medium text-slate-700">
            Try again tomorrow to refresh and update this social.
          </p>
        )}
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-[#1B9DA2] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#168589]"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default DailyLimitModal;
